/**
 * The four steps, shown as the artifacts they actually produce.
 *
 * Numbering is used because this genuinely is a sequence — you cannot score
 * before you upload — so the order carries information the reader needs.
 * Each node shows the thing that exists at that stage rather than an icon
 * standing in for it, which makes the diagram double as a product preview.
 */
const STEPS = [
  { n: "01", title: "Upload", artifact: "resume.pdf", kind: "file",
    body: "We extract the text and structure it into editable sections." },
  { n: "02", title: "Add a job", artifact: "Staff SRE · Acme", kind: "file",
    body: "Paste any posting. We pull out the required and preferred skills." },
  { n: "03", title: "Score", artifact: "87", kind: "score",
    body: "A match score, the keywords you’re missing, and what to do about them." },
  { n: "04", title: "Tailor", artifact: "Facts unchanged", kind: "verified",
    body: "Approve each rewrite. Nothing is added that wasn’t already yours." },
];

const ARTIFACT = {
  file: "bg-white border-sand text-stone-600 font-mono text-xs",
  score: "bg-brand border-brand text-white font-heading text-2xl font-bold",
  verified: "bg-verified/10 border-verified/30 text-verified font-medium text-xs",
};

export default function Pipeline() {
  return (
    <ol className="grid md:grid-cols-4 gap-x-5 gap-y-10" data-testid="landing-pipeline">
      {STEPS.map((s, i) => (
        <li key={s.n} className="relative">
          {/* The connector makes the sequence visible; it stops at the last
              node rather than trailing off past it. */}
          {i < STEPS.length - 1 && (
            <span
              aria-hidden="true"
              className="hidden md:block absolute top-7 left-full w-5 h-px bg-sand"
            />
          )}
          <div className={`h-14 inline-flex items-center px-4 border rounded-sm ${ARTIFACT[s.kind]}`}>
            {s.artifact}
          </div>
          <div className="mt-5 flex items-baseline gap-2">
            <span className="font-mono text-[11px] text-stone-600">{s.n}</span>
            <h3 className="font-heading text-xl font-bold tracking-tight text-ink">{s.title}</h3>
          </div>
          <p className="mt-1.5 text-sm text-stone-600 leading-relaxed">{s.body}</p>
        </li>
      ))}
    </ol>
  );
}
